import { updateUserOptions } from 'owa-options-core';
import {
    saveCalendarMailboxConfiguration,
    updateCalendarMailboxConfiguration,
} from 'owa-calendar-configuration';
import updateSurfaceOptions from '../data/actions/updateSurfaceOptions';
import { logDataOnSaveWeekStartDayQuickSetting } from '../utils/logDataOnSaveAppearance';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';

/**
 *  Called when we update week start day option from quick settings panel.
 *  Updates user options so that the changes are reflected in current user session
 *  Updates the calendar configuration on local store and on server
 */
async function saveWeekStartDayQuickSetting(dayOfWeek: number) {
    let WeekStartDay = dayOfWeek;

    const partialCalendarMailboxConfiguration: MailboxCalendarConfiguration = {
        WeekStartDay,
    };

    updateUserOptions(partialCalendarMailboxConfiguration);
    updateCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);

    /**
     * Action dispatched to call an orchestrator in owa-calendar which will initialize surface options.
     */
    updateSurfaceOptions();

    await saveCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);
    logDataOnSaveWeekStartDayQuickSetting();
}

export default saveWeekStartDayQuickSetting;
